import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import upsertInteractionByChannelId from './lib/upsertInteractionByChannelId';
import {
  ChannelClassificationInput,
  InteractionChannel,
  InteractionStatus,
  InteractionUpsertInput,
} from '@api/generated/graphql';
import _ from 'lodash';
import { ITask, TaskState } from '@modules/TasksModule/types';

export enum CallClassificationType {
  Abandoned,
  Unbooked,
  Excused,
  Booked,
  NotLead,
}

class InteractionsModule extends AppModule {
  private throttledUpsertInteraction: any;

  override preload(): void {
    this.throttledUpsertInteraction = _.throttle(
      this.upsertInteraction.bind(this),
      3000,
    );

    this.app.events.on('task.updated', async (task: ITask) => {
      // need to write task information to the interaction here
      // throttle to keep from overloading api
      if (this.isRecordableState(task)) {
        this.throttledUpsertInteraction(task);
      }
    });
  }

  public async writeClassificationInfo(
    task: ITask,
    info: ChannelClassificationInput,
  ) {
    if (!this.isRecordableState(task)) {
      throw new Error('Task does not support classification info');
    }
    return await this.upsertInteraction(task, { channelClassification: info });
  }

  private isRecordableState(task: ITask): boolean {
    return (
      task.attributes.recordInteraction === true &&
      (task.state === TaskState.Accepted ||
        task.state === TaskState.Completed ||
        task.state === TaskState.WrapUp)
    );
  }

  private async upsertInteraction(
    task: ITask,
    extra: Partial<InteractionUpsertInput> = {},
  ) {
    if (!task.tenantId) {
      return;
    }

    this.app.logger.info('Interaction sync', task.id, task.state);
    return await upsertInteractionByChannelId(task.id, task.tenantId, {
      channel: InteractionChannel.InboundVoice,
      from: task.from,
      to: task.to,
      tenantId: task.tenantId,
      tenantName: '',
      status:
        task.state === TaskState.Completed
          ? InteractionStatus.Completed
          : InteractionStatus.Open,
      customerId: task.attributes.customerId,
      customerName: task.attributes.customerId && task.displayName,
      ...extra,
    });
  }
}

export default new InteractionsModule(
  appManager.events,
  appManager.logger('Interactions'),
);
